import * as React from "react";
import { Label } from "../Label";
import { DateTime } from "../DateTime";

export class League extends React.Component<{ label: string, date?: string, time?: string }, {}> {
    render() {
        return (
            <span className="rj-racing-future-events__league">
                <Label label={this.props.label} />
                <DateTime date={this.props.date} time={this.props.time} />
            </span>
        )
    }
}